import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/api/client'

export function useDeploys(limit = 50) {
  return useQuery({
    queryKey: ['deploys', limit],
    queryFn: () => api.listDeploys(limit),
    refetchInterval: 10_000,
  })
}

export function usePendingDeploys() {
  return useQuery({
    queryKey: ['deploys', 'pending'],
    queryFn: api.listPendingDeploys,
    refetchInterval: 10_000,
  })
}

export function useApproveDeploy() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => api.approveDeploy(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['deploys'] })
      qc.invalidateQueries({ queryKey: ['services'] })
      qc.invalidateQueries({ queryKey: ['service-deploys'] })
    },
  })
}

export function useSkipDeploy() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => api.skipDeploy(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['deploys'] })
      qc.invalidateQueries({ queryKey: ['service-deploys'] })
    },
  })
}

export function useRedeploy() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => api.redeploy(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['deploys'] })
      qc.invalidateQueries({ queryKey: ['services'] })
      qc.invalidateQueries({ queryKey: ['service-deploys'] })
    },
  })
}
